export default {
    account_redesign: {
        // Sub-account management
        sub_account_management: 'Sub-Account Management',
        personal_account: 'Personal Account',
        enterprise_account: 'Enterprise Account',
        create_sub_account: 'Create Sub-Account',
        manage_scope: 'Manage Scopes',
        manage_role: 'Manage Roles',
        username: 'Username',
        email: 'Email',
        display_name: 'Display Name',
        role: 'Role',
        scope: 'Scope',
        status: 'Status',
        expire_time: 'Expire Time',
        create_time: 'Create Time',
        active_time: 'Active Time',
        operation: 'Action',
        edit_role: 'Edit Role',
        edit_scope: 'Edit Scope',
        reinvite: 'Resend Invitation',
        delete: 'Delete',
        unfreeze: 'Unfreeze',
        invite_validity: 'Invitation Validity',
        hours_48: '48 hours',
        hours_72: '72 hours',
        all_architecture: 'All Architecture',
        cancel: 'Cancel',
        confirm: 'Confirm',
        create: 'Create',
        save: 'Save',
        // Create sub-account success
        create_success: 'Sub-Account Created Successfully',
        initial_password: 'Initial Password',
        password_show_once_warning: 'This password is shown only once. Please save it securely.',
        first_login_warning: 'User will be forced to change password on first login',
        invite_expire_warning: 'Invitation must be resent after expiration',
        download_csv: 'Download CSV',
        send_email_invite: 'Send Email Invitation',
        close: 'Close',
        // Scope management
        scope_management: 'Scope Management',
        create_scope: 'Create Scope',
        scope_name: 'Scope Name',
        associated_architecture: 'Associated Architecture',
        member_count: 'Members',
        description: 'Description',
        edit: 'Edit',
        select_architecture: 'Select architecture node',
        // Root transfer
        root_transfer: 'Transfer Root Privileges',
        transfer_warning: 'After transfer, you will lose Root privileges and be downgraded to a regular enterprise user. This operation is irreversible.',
        transfer_to: 'Transfer to',
        select_user: 'Select user',
        transfer_user_tip: 'Only activated users in the same enterprise are shown',
        current_root_password: 'Current Root Password',
        password_confirm_tip: 'For identity confirmation',
        confirm_transfer: 'Confirm Transfer',
        transfer_success: 'Transfer successful. The original Root has been frozen.',
        // Root unfreeze
        root_unfreeze: 'Root Unfreeze',
        unfreeze_tip: 'After unfreezing, the original Root user will be restored as a regular enterprise user. You can assign a new role and scope.',
        assign_role: 'Assign Role',
        assign_scope: 'Assign Scope',
        confirm_unfreeze: 'Confirm Unfreeze',
        unfreeze_success: 'Unfreeze successful',
        // Status
        status_active: 'Active',
        status_pending: 'Pending',
        status_expired: 'Expired',
        status_frozen: 'Frozen',
        status_disabled: 'Disabled',
        // Tips
        tip_delete_sub_account: 'Are you sure you want to delete this UAM Account? The user will no longer be able to log in.',
        tip_delete_uam_accounts_batch: 'Are you sure you want to delete these UAM Accounts? These users will no longer be able to log in.',
        no_role_add: 'No role? Click to add',
        no_scope_add: 'No scope? Click to add',
        tip_delete_scope: 'Are you sure you want to delete this scope? Associated users will lose data access for this scope.',
        tip_reinvite: 'Are you sure you want to resend the invitation? A new initial password will be generated.',
        tip_select_user: 'Please select a target user',
        tip_input_password: 'Please enter the current Root password',
        // Password policy
        password_policy_tip: 'At least 8 characters, must include uppercase + lowercase + digits + special symbols',
        password_mismatch: 'The passwords entered do not match',
        // Empty
        no_data: 'No data',
        // Phase 4: Security settings
        security_settings: 'Security Settings',
        user_list: 'User List',
        select_users: 'Select users (multi-select)',
        selected_count: '{count} users selected',
        batch_assign: 'Batch Assign',
        assign_mode: 'Assign Mode',
        mode_overwrite: 'Overwrite (replace existing roles and scopes)',
        mode_append: 'Append (add to existing)',
        permission_preview: 'Permission Preview',
        // Wizard-style new account
        wizard_step_basic: 'Basic Info',
        wizard_step_role: 'Role Assignment',
        wizard_step_scope: 'Scope Assignment',
        wizard_prev: 'Previous',
        wizard_next: 'Next',
        company_required: 'Please select a Company',
        company_already_has_root: 'This Company already has a root account. One Company can only have one root account.',
        company_id: 'Company ID',
        company_id_placeholder: 'Enter Company ID',
        company_id_required: 'Company ID is required',
        company_id_not_exist: 'Company ID does not exist',
        create_personal_success: 'Create Personal Account Success',
        create_enterprise_success: 'Create Enterprise Account Success',
        batch_assign_success: 'Batch assignment successful',
        organization: 'Organization',
        company: 'Company',
        new_scope: 'New Scope',
        edit_scope: 'Edit Scope',
        organization_required: 'Please select organization',
        scope_name_required: 'Please enter scope name',
        actions: 'Actions',
        new_personal_account: 'New Personal Account',
        edit_personal_account: 'Edit Personal Account',
        new_enterprise_account: 'New Enterprise Account',
        edit_enterprise_account: 'Edit Enterprise Account',
        operate_failed: 'Operation Failed',
        // Phase 4: Enterprise admin
        enterprise_admin: 'Enterprise Admin',
        company_apply_list: 'Company ID Applications',
        company_list: 'Enterprise List',
        audit_log: 'Audit Records',
        company_name: 'Company',
        contact_name: 'Contact',
        contact_mobile: 'Mobile/Phone',
        contact_email: 'Email',
        apply_description: 'Description',
        apply_status: 'Status',
        apply_time: 'Apply Time',
        audit_user: 'Auditor',
        audit_time: 'Audit Time',
        audit_remark: 'Audit Remark',
        company_id: 'Company ID',
        audit: 'Audit',
        approve: 'Approve',
        reject: 'Reject',
        status_pending: 'Pending',
        status_approved: 'Approved',
        status_rejected: 'Rejected',
        company: 'Company',
        mobile: 'Mobile/Phone',
        total_count: 'Total',
        active_count: 'Active',
        pending_count: 'Pending',
        disabled_count: 'Disabled',
        view_detail: 'View Detail',
        manage_users: 'Manage Users',
        activate: 'Activate',
        disable: 'Disable',
        tip_audit_approve: 'Approve this application? A Company ID will be generated.',
        tip_audit_reject: 'Reject this application? Please provide a reason.',
        audit_failed: 'Audit failed',
        audit_err_name_conflict: 'Company name already exists, cannot approve',
        audit_err_code_conflict: 'Company ID already exists, cannot approve',
        audit_err_email_conflict: 'Email already exists, cannot approve',
        audit_err_phone_conflict: 'Phone number already exists, cannot approve',
        audit_err_not_found: 'Application not found',
        audit_err_already_processed: 'Application has already been processed',
        tip_disable_company: 'Disable this enterprise? All users of this enterprise will not be able to log in.',
        tip_activate_company: 'Activate this enterprise?',
        enter_audit_remark: 'Please enter audit remark',
        uam_account: 'UAM Account',
        enable: 'Enable',
        disable: 'Disable',
        pending: 'Pending',
        expire: 'Expired',
        ok: 'OK',
        // Success create UAM account dialog
        success_create_title: 'UAM Account Created Successfully',
        success_create_body: 'UAM account has been created successfully.',
        success_create_warning: 'Important: This is the only time you can view or download the initial password (or credentials) for this user. Please save it immediately, otherwise it cannot be recovered later.',
        success_create_choose: 'Choose one of the following methods to obtain the credentials:',
        success_create_csv_desc: 'Download CSV file: Click the button below to download a CSV file containing the username, password, and login URL.',
        success_create_show_desc: 'Show password: Click the button below to view the password directly on the screen.',
        success_create_security: 'Security reminder: Please share the credentials with the user through a secure method (such as encrypted email or internal communication tools), and remind the user to change the password immediately after first login.',
        success_create_48h_warning: 'Please log in and change the password within 48 hours. Accounts not activated within 48 hours will automatically expire.',
        download_csv_file: 'Download .csv',
        show_password: 'Show Password',
        hide_password: 'Hide Password',
        csv_username: 'Username',
        csv_password: 'Password',
        csv_login_url: 'Login URL',
        // Edit UAM Account dialog
        edit_uam_account: 'Edit UAM Account',
        // Re-invite success dialog
        reinvite_success_title: 'UAM Account Re-invited',
        reinvite_success_body: 'The UAM account has been re-invited. A new initial password has been generated.',
        personal_reinvited_title: 'Personal Account Re-invited Successfully',
        enterprise_reinvited_title: 'Enterprise Account Re-invited Successfully',
        mobile_phone: 'Mobile/Phone',
        // Delete confirmation dialog
        delete_confirm_title: 'Delete UAM Account',
        delete_confirm_tip: 'This action is irreversible. To prevent accidental deletion, please type the display name of the UAM account to confirm:',
        delete_confirm_placeholder: 'Please enter the display name',
        delete_confirm_mismatch: 'Display name does not match, cannot delete',
        delete_confirm_account: 'Current Account',
        delete_confirm_display_name: 'Display Name',
        // Re-invite restriction
        reinvite_disabled: 'Enabled accounts do not need re-invitation',
        // Re-invite failed
        reinvite_failed: 'Re-invitation failed, please try again later',
        // Role permission tree
        role_permission: 'Role Permissions',
        // Batch enable/disable
        batch_disable: 'Batch Disable',
        batch_enable: 'Batch Enable',
        batch_disable_tip: 'Are you sure you want to disable the selected UAM accounts?',
        batch_enable_tip: 'Are you sure you want to enable the selected UAM accounts?',
        batch_select_empty: 'Please select accounts first',
        // Enterprise Admin batch operations
        apply: 'Apply',
        audit_batch: 'Audit',
        delete: 'Delete',
        applicant: 'Applicant',
        auditor: 'Auditor',
        notify_email: 'Notify audit result by email',
        apply_record_audit: 'Application Audit',
        apply_record_detail: 'Application Detail',
        batch_audit_title: 'Batch Audit',
        batch_audit_tip: 'Batch audit {count} selected records',
        batch_delete_title: 'Batch Delete',
        batch_delete_tip: 'Batch delete {count} selected records, this action is irreversible',
        batch_delete_pending_tip: 'Selected records contain pending applications, pending records cannot be deleted',
        select_at_least_one: 'Please select at least one record',
        approve_icon: 'Approve',
        reject_icon: 'Reject',
        delete_icon: 'Delete',
        audit_result: 'Audit Result',
        audit_remark_placeholder: 'Please enter audit remark (optional)',
        batch_delete_confirm: 'Confirm delete selected records? This action is irreversible',
        apply_form_title: 'Apply for Company ID',
        apply_form_tip: 'Fill in the form below to apply for a Company ID',
        apply_success: 'Application submitted successfully',
        // Security settings page
        sec_group_list: 'Security Group',
        sec_permissions: 'Permissions',
        sec_group_unit: '',
        sec_no_group: 'No Groups',
        sec_search_group: 'Search group name',
        sec_select_company: 'Select Company',
        sec_new_group: 'New Group',
        sec_group_name: 'Group Name',
        sec_creator: 'Creator',
        sec_assoc_scope: 'Associated Scope',
        sec_assoc_role: 'Associated Role',
        sec_not_assoc: 'Not Associated',
        sec_tab_basic: 'Basic Info',
        sec_tab_scope: 'Scope',
        sec_tab_role: 'Role',
        sec_tab_account: 'Account',
        sec_select_scope: 'Please select scope',
        sec_select_role: 'Please select role',
        sec_scope_tree: 'Scope Tree',
        sec_role_tree: 'Role Permission Tree',
        sec_account_count: '{count} accounts in total',
        sec_add_account: 'Add Account',
        sec_search_account: 'Search account/username',
        sec_col_account: 'Account',
        sec_col_mobile: 'Mobile/Phone',
        sec_col_email: 'Email',
        sec_tip_remove: 'Remove account "{name}"?',
        sec_tip_select_group: 'Please select a group from the left',
        sec_input_group_name: 'Please enter group name',
        sec_input_desc: 'Please enter description',
        sec_select_company_required: 'Please select company',
        sec_create_success: 'Created successfully',
        sec_save_success: 'Saved successfully',
        sec_remove_success: 'Removed',
        sec_add_success: 'Successfully added {count} accounts',
        sec_assoc_scope_success: 'Scope associated successfully',
        sec_assoc_role_success: 'Role associated successfully',
        sec_unassoc_success: 'Association removed',
        sec_add_account_title: 'Add Account',
        sec_add_btn: 'Add',
        sec_search_btn: 'Search',
        sec_created_at: 'Created at {time}',
        sec_company_label: 'Company: {name}',
        sec_save_failed: 'Save failed',
        sec_create_failed: 'Create failed',
        sec_add_failed: 'Add failed',
        sec_remove_failed: 'Remove failed',
        sec_operate_failed: 'Operation failed',
        // User Profile redesign
        up_basic_info: 'Basic Info',
        up_functions: 'Functions',
        up_active: 'Active',
        up_edit_profile: 'Edit Profile',
        up_res_desc: 'View accessible menus, roles and permissions',
        up_pwd_desc: 'Change current account login password',
        up_sig_desc: 'Edit or redraw handwritten signature',
        up_unit_desc: 'Temperature data display unit (°C / °F / K)',
        up_locate: 'Location',
        up_locate_desc: 'View enterprise or personal space location on map',
        up_locate_no_data: 'No location data available for current account',
        up_sig_set: 'Set',
        up_sig_not_set: 'Not Set',
        up_items: 'items',
        up_avatar_too_large: 'Image size cannot exceed 2MB',
        up_avatar_format: 'Image can only be JPG, JPEG, BMP, PNG format',
        up_mobile_phone: 'Mobile/Phone',
        up_company_id: 'Company ID',
        up_personal_space: 'Personal Space',
        up_apply_enterprise: 'Apply Enterprise Account',
        up_apply_enterprise_desc: 'Upgrade personal account to enterprise account',
        up_root_transfer: 'Enterprise Prime Account Switch',
        up_root_transfer_desc: 'Transfer prime account permissions to another user',
        up_change_email: 'Change Email',
        up_email_readonly: 'Only enterprise prime account can change email',
        up_email_same_as_current: 'New email cannot be the same as current email',
        up_email_change_desc: 'Verify password then change email via verification code',
        up_email_change_new_email: 'New Email',
        up_email_change_password: 'Current Password',
        up_email_change_tip: 'Verification code will be sent to the new email, valid for 5 minutes',
        up_email_verify_title: 'Email Verification',
        up_email_verify_code: 'Verification Code',
        up_email_verify_tip: 'Code sent to {email}, valid for 5 minutes',
        up_email_resend: 'Resend',
        up_email_resend_wait: 'Resend in {s}s',
        up_email_verify_success: 'Email changed successfully',
        up_email_verify_fail: 'Verification failed',
        up_email_code_sent: 'Code sent',
        up_email_sending: 'Sending Code',
        up_email_sending_tip: 'Sending verification code to {email}, please wait...',
        up_email_send_failed: 'Send Failed',
        up_email_send_failed_tip: 'Failed to send verification code. Please return to User Profile and try again',
        up_email_no_pending: 'No pending email change request. Please apply from User Profile',
        up_email_back_to_profile: 'Back to User Profile',
        up_apply_enterprise_title: 'Apply Enterprise Account',
        up_apply_enterprise_tip: 'After upgrade, your account becomes enterprise root. This cannot be undone',
        up_apply_company_name: 'Company Name',
        up_apply_company_code: 'Company ID',
        up_apply_email: 'Email',
        up_apply_mobile: 'Mobile',
        up_apply_password: 'Current Password',
        up_apply_confirm: 'Confirm Upgrade',
        up_apply_success: 'Upgrade successful, please login again',
        up_apply_company_code_exists: 'This Company ID is already in use, please choose another',
        up_apply_company_available: 'Company ID is available',
        up_apply_company_not_exist: 'Company ID does not exist, please apply first',
        up_root_transfer_title: 'Enterprise Prime Account Switch',
        up_transfer_to: 'Transfer To',
        up_select_user: 'Select user',
        up_current_password: 'Current Password',
        up_confirm_transfer: 'Confirm Transfer',
        up_transfer_warning: 'After transfer, current account will be frozen. This cannot be undone',
        up_transfer_success: 'Transfer successful'
    }
}
